/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */
 // SUBTITLE INSTAFEED

//  const instafeedSubtitle = `<p class="instafeedSubtitle"> Our </p>`;

//  window.addEventListener('load', function() {
//    const instafeed = document.querySelector('.instagenie-feed');
//    instafeed.insertAdjacentHTML('afterBegin', instafeedSubtitle);
// });

// MAIN PAGE ACCORDION

(function () {
  const acc = document.getElementsByClassName('faqs-title');
  let i;
 
  for (i = 0; i < acc.length; i++) {
     acc[i].addEventListener('click', function () {
         this.classList.toggle('active');
         let panel = this.nextElementSibling;
         if (panel.style.maxHeight) {
             panel.style.maxHeight = null;
         } else {
             panel.style.maxHeight = panel.scrollHeight + 'px';
         }
     });
 }
})()


// PRODUCT PAGE  ACCORDION

const accProduct = document.querySelectorAll('.faqs-title_product-page');

accProduct.forEach((item) => {
  item.addEventListener('click', function () {
        this.classList.toggle('activeP');
         let panelP = this.nextElementSibling;
         if (panelP.style.maxHeight) {
             panelP.style.maxHeight = null;
         } else {
             panelP.style.maxHeight = panelP.scrollHeight + 'px';
         }
     });
});

// FOOTER LANGUAGE SWITCH

  document.querySelectorAll("#localeItem").forEach(item => {
    item.addEventListener("click", event=>{
      document.getElementById("localeCode").value = item.getAttribute("lang");
      document.getElementById("localization_form_tag").submit();
    })
  })

// PINK COLOR SHOP ALL

const linkUnderlinePink = document.querySelectorAll(".link_underline_pink ");
for (let item of linkUnderlinePink){
  if(item.innerHTML.replace(/ /g,'').toLowerCase() == "shopall"){
    item.style.borderTop = '1px solid #dfdfdfa1';
    item.style.width = '100%';
    item.style.paddingTop = '10px';
    item.classList.add("link_not_underline");
  }
};


// FORM PRODUCT PAGE

window.addEventListener('load', function() {
  // let formText = document.querySelectorAll('.mw-option');
  let formText = document.querySelectorAll('.mw-option--type-select');
  const waitForFormText = setInterval(() => {
    formText = document.querySelectorAll('.mw-option--type-select');
    if (formText.length > 0) {
      clearInterval(waitForFormText);
      formText.forEach(element => {
        const formLabel = element.querySelector('.mw-text');
        const formSelect = element.querySelector('[data-hidden]');
        const mwOptionControl = element.querySelector('.mw-option__control');
        formSelect.innerText = `${formLabel.innerText}`;
        mwOptionControl.style.display = 'block';
        const mwStackItem = document.querySelectorAll('.mw-stack__item--fill');
        mwStackItem.forEach(item => {
          const arrow = `<div class="select-arrow">
            <svg class="select-arrow_svg" role="presentation" viewBox="0 0 19 12">
              <polyline fill="none" stroke="currentColor" points="17 2 9.5 10 2 2" fill-rule="evenodd" stroke-width="2" stroke-linecap="square"></polyline>
            </svg>
          </div>`;
          item.insertAdjacentHTML('afterbegin', arrow);
        });
      });
    }
  }, 100);
});


// ANCHORS 

const anchors = document.querySelectorAll('a[href*="#"]')
for (let anchor of anchors) {
  anchor.addEventListener('click', function (e) {
    e.preventDefault()
    
    const blockID = anchor.getAttribute('href').substr(1)
    
    document.getElementById(blockID).scrollIntoView({
      behavior: 'smooth',
      block: 'start'
    })
  })
}

// hide skeleton on product page

window.onload = () => {
  if (document.body.classList.contains('template-product')) {
    document.querySelector('.skeleton_wr').classList.add('hidden')
    document.querySelector('.mw_style').remove()
  }
}

// link in measurements's input + Measurements ID status
(function () {
  if (!document.body.classList.contains('template-product')) {
    return;
  }

  const MEASUREMENTS_LOOKUP_URL = 'https://measurements.brightandshinystore.com/lookup.php';

  let lastLoadedCode = '';
  const MEASUREMENTS_REQUEST_TIMEOUT = 10000;

  let isLoadingMeasurements = false;
  let measurementsRequestController = null;
  let measurementsInputTimer = null;
  let measurementsValueWatcher = null;
  let lastSeenMeasurementsCode = '';
  let lastMeasurementsSuccessMessage = 'Measurements loaded successfully.';

  function getMeasurementsInput() {
    return document.querySelector('.measurements input');
  }

  function getMeasurementsControl() {
    return document.querySelector('.measurements .mw-option__control');
  }

  function getLineItemsContainer() {
    return document.querySelector('.hidden_line_items');
  }

  const BS_M2M_FIELD_MAP = {
    gender: { selector: '.bs-m2m-gender', keys: ['gender', 'Gender'] },
    '01': { selector: '.bs-m2m-01', keys: ['1', '01', 'head', 'Head', '1. Head (cm)'] },
    '02': { selector: '.bs-m2m-02', keys: ['2', '02', 'head_vertical', 'head_vertical_circumference', 'Head vertical', 'Head vertical (cm)', '2. Head vertical (cm)', 'head_vertical_length', 'Head vertical length', 'Head vertical length (cm)', '2. Head vertical length (cm)'] },
    '03': { selector: '.bs-m2m-03', keys: ['3', '03', 'neck', 'Neck', '3. Neck (cm)'] },
    '04': { selector: '.bs-m2m-04', keys: ['4', '04', 'shoulder', 'Shoulder', '4. Shoulder (cm)'] },
    '05': { selector: '.bs-m2m-05', keys: ['5', '05', 'armhole_circumference', 'Armhole circumference', '5. Armhole circumference (cm)'] },
    '06': { selector: '.bs-m2m-06', keys: ['6', '06', 'full_torso', 'Full torso', '6. Full torso (cm)'] },
    '07': { selector: '.bs-m2m-07', keys: ['7', '07', 'torso_from_the_neck', 'Torso from the neck', '7. Torso from the neck (cm)'] },
    '08': { selector: '.bs-m2m-08', keys: ['8', '08', 'bust', 'Bust', '8. Bust (cm)'] },
    '09': { selector: '.bs-m2m-09', keys: ['9', '09', 'under_the_bust', 'Under the bust', '9. Under the bust (cm)'] },
    '10': { selector: '.bs-m2m-10', keys: ['10', 'bust_width', 'Bust width', '10. Bust width (cm)'] },
    '11': { selector: '.bs-m2m-11', keys: ['11', 'bust_height', 'Bust height', '11. Bust height (cm)'] },
    '12': { selector: '.bs-m2m-12', keys: ['12', 'waist', 'Waist', '12. Waist (cm)'] },
    '13': { selector: '.bs-m2m-13', keys: ['13', 'hips', 'Hips', '13. Hips (cm)'] },
    '14': { selector: '.bs-m2m-14', keys: ['14', 'upper_arm', 'Upper arm', '14. Upper arm (cm)'] },
    '15': { selector: '.bs-m2m-15', keys: ['15', 'elbow', 'Elbow', '15. Elbow (cm)'] },
    '16': { selector: '.bs-m2m-16', keys: ['16', 'wrist', 'Wrist', '16. Wrist (cm)'] },
    '17': { selector: '.bs-m2m-17', keys: ['17', 'palm', 'Palm', '17. Palm (cm)'] },
    '18': { selector: '.bs-m2m-18', keys: ['18', 'arm_length_to_wrist', 'Arm length to wrist', '18. Arm length to wrist (cm)'] },
    '19': { selector: '.bs-m2m-19', keys: ['19', 'arm_length_to_tip_of_middle_finger', 'Arm length to tip of middle finger', '19. Arm length to tip of middle finger (cm)'] },
    '20': { selector: '.bs-m2m-20', keys: ['20', 'thigh', 'Thigh', '20. Thigh (cm)'] },
    '21': { selector: '.bs-m2m-21', keys: ['21', 'knee', 'Knee', '21. Knee (cm)'] },
    '22': { selector: '.bs-m2m-22', keys: ['22', 'under_knee', 'Under knee', '22. Under knee (cm)'] },
    '23': { selector: '.bs-m2m-23', keys: ['23', 'calf', 'Calf', '23. Calf (cm)'] },
    '24': { selector: '.bs-m2m-24', keys: ['24', 'ankle', 'Ankle', '24. Ankle (cm)'] },
    '25': { selector: '.bs-m2m-25', keys: ['25', 'leg_length_from_waist_to_base', 'Leg length from waist to base', '25. Leg length from waist to base (cm)'] },
    '26': { selector: '.bs-m2m-26', keys: ['26', 'inseam_length', 'Inseam length', '26. Inseam length (cm)'] },
    '27': { selector: '.bs-m2m-27', keys: ['27', 'step_measured_to_base', 'Step measured to base', '27. Step measured to base (cm)'] },
    '28': { selector: '.bs-m2m-28', keys: ['28', 'instep_girth', 'Instep girth', '28. Instep girth (cm)'] },
    '29': { selector: '.bs-m2m-29', keys: ['29', 'foot_length', 'Foot length', '29. Foot length (cm)'] },
    '30': { selector: '.bs-m2m-30', keys: ['30', 'height', 'Height', '30. Height (cm)'] }
  };

  function normalizeMeasurementsData(responseData) {
    const measurementsData = {};

    if (!responseData) {
      return measurementsData;
    }

    if (responseData.gender !== undefined && responseData.gender !== null && responseData.gender !== '') {
      measurementsData.gender = responseData.gender;
      measurementsData.Gender = responseData.gender;
    }

    if (Array.isArray(responseData.measurements)) {
      responseData.measurements.forEach((measurement, index) => {
        if (!measurement) {
          return;
        }

        const measurementNumber = String(index + 1);
        const paddedMeasurementNumber = measurementNumber.padStart(2, '0');
        const measurementName = String(measurement.name || '').trim();
        const measurementValue = measurement.value;

        measurementsData[measurementNumber] = measurementValue;
        measurementsData[paddedMeasurementNumber] = measurementValue;

        if (measurementName) {
          measurementsData[measurementName] = measurementValue;
          measurementsData[`${measurementNumber}. ${measurementName}`] = measurementValue;
          measurementsData[`${measurementNumber}. ${measurementName} (cm)`] = measurementValue;
        }
      });
    }

    return measurementsData;
  }

  function getMeasurementValue(data, possibleKeys) {
    for (const key of possibleKeys) {
      if (data && data[key] !== undefined && data[key] !== null && data[key] !== '') {
        return data[key];
      }
    }

    return '';
  }

function isSkippedMeasurementPlaceholder(value) {
  if (value === undefined || value === null) {
    return true;
  }

  const normalizedValue = String(value).trim().replace(',', '.');

  if (!normalizedValue) {
    return true;
  }

  const numericValue = Number(normalizedValue);

  return !Number.isFinite(numericValue) || numericValue <= 1;
}

  const BS_M2M_SIZE_SURCHARGE_SELECTOR = '.bs-m2m-size-surcharge';
  const BS_M2M_SIZE_SURCHARGE_MESSAGES = {
    none: 'Measurements loaded successfully.',
    surcharge: 'Measurements loaded successfully. Size surcharge applied because one of your measurements is above our standard XXL range. This covers additional material and production time.',
    manualReview: 'Measurements loaded successfully. Your measurements are above our standard XXL range and require manual surcharge review. We will check the details and contact you if an additional payment is needed.'
  };

  function setApoHiddenField(containerSelector, value) {
    const container = document.querySelector(containerSelector);

    if (!container) {
      return false;
    }

    const field = container.querySelector('input, textarea');

    if (!field) {
      return false;
    }

    field.value = value === undefined || value === null || value === '' ? '' : value;
    field.dispatchEvent(new Event('input', { bubbles: true }));
    field.dispatchEvent(new Event('change', { bubbles: true }));

    return true;
  }

  function populateApoMeasurementFields(responseData) {
    const measurementsData = normalizeMeasurementsData(responseData);

    Object.entries(BS_M2M_FIELD_MAP).forEach(([fieldKey, config]) => {
      const value = getMeasurementValue(measurementsData, config.keys);

      if (fieldKey !== 'gender' && isSkippedMeasurementPlaceholder(value)) {
        setApoHiddenField(config.selector, '');
        return;
      }

      if (fieldKey === 'gender' && (value === undefined || value === null || String(value).trim() === '')) {
        setApoHiddenField(config.selector, '');
        return;
      }

      setApoHiddenField(config.selector, value);
    });
  }

  function clearApoMeasurementFields() {
    Object.values(BS_M2M_FIELD_MAP).forEach((config) => {
      setApoHiddenField(config.selector, '');
    });
  }

  function getSizeSurchargeSelect() {
    const container = document.querySelector(BS_M2M_SIZE_SURCHARGE_SELECTOR);

    if (!container) {
      return null;
    }

    return container.querySelector('select');
  }

function normalizeSurchargeOptionText(text) {
  return String(text || '')
    .replace(/[–—−]/g, '-')
    .replace(/\s+/g, ' ')
    .trim()
    .toLowerCase();
}

function updateSizeSurchargeSelect(value) {
  const select = getSizeSurchargeSelect();

  if (!select) {
    console.warn('Size surcharge select not found. Check .bs-m2m-size-surcharge APO option.');
    return false;
  }

  if (!value) {
    select.value = '';
    select.dispatchEvent(new Event('input', { bubbles: true }));
    select.dispatchEvent(new Event('change', { bubbles: true }));
    return true;
  }

  const normalizedTarget = normalizeSurchargeOptionText(value);

  const matchingOption = Array.from(select.options).find((option) => {
    const optionValue = normalizeSurchargeOptionText(option.value);
    const optionText = normalizeSurchargeOptionText(option.textContent);

    return (
      optionValue === normalizedTarget ||
      optionText === normalizedTarget ||
      optionText.startsWith(normalizedTarget)
    );
  });

  if (!matchingOption) {
    console.warn(
      'Size surcharge option not found:',
      value,
      Array.from(select.options).map((option) => option.textContent.trim())
    );
    return false;
  }

  select.value = matchingOption.value;

  select.dispatchEvent(new Event('input', { bubbles: true }));
  select.dispatchEvent(new Event('change', { bubbles: true }));

  return true;
}

  function clearSizeSurchargeSelect() {
    updateSizeSurchargeSelect('');
  }

function parseSurchargeMeasurementValue(value) {
  if (value === undefined || value === null) {
    return null;
  }

  const normalizedValue = String(value).trim().replace(',', '.');

  if (!normalizedValue) {
    return null;
  }

  const numericValue = Number(normalizedValue);

  if (!Number.isFinite(numericValue) || numericValue <= 1) {
    return null;
  }

  return numericValue;
}

  function applySizeSurchargeSelection(responseData) {
    const measurementsData = normalizeMeasurementsData(responseData);
    const surchargeMeasurements = ['08', '12', '13']
      .map((fieldKey) => parseSurchargeMeasurementValue(getMeasurementValue(
        measurementsData,
        BS_M2M_FIELD_MAP[fieldKey].keys
      )))
      .filter((value) => value !== null);

    if (!surchargeMeasurements.length) {
      clearSizeSurchargeSelect();
      return BS_M2M_SIZE_SURCHARGE_MESSAGES.none;
    }

    const maxMeasurement = Math.max(...surchargeMeasurements);

    if (maxMeasurement <= 120) {
      clearSizeSurchargeSelect();
      return BS_M2M_SIZE_SURCHARGE_MESSAGES.none;
    }

    if (maxMeasurement <= 130) {
      updateSizeSurchargeSelect('121–130 cm / above XXL');
      return BS_M2M_SIZE_SURCHARGE_MESSAGES.surcharge;
    }

    if (maxMeasurement <= 140) {
      updateSizeSurchargeSelect('131–140 cm / above XXL');
      return BS_M2M_SIZE_SURCHARGE_MESSAGES.surcharge;
    }

    if (maxMeasurement <= 150) {
      updateSizeSurchargeSelect('141–150 cm / above XXL');
      return BS_M2M_SIZE_SURCHARGE_MESSAGES.surcharge;
    }

    if (maxMeasurement <= 160) {
      updateSizeSurchargeSelect('151–160 cm / above XXL');
      return BS_M2M_SIZE_SURCHARGE_MESSAGES.surcharge;
    }

    updateSizeSurchargeSelect('161+ cm / manual surcharge review');
    return BS_M2M_SIZE_SURCHARGE_MESSAGES.manualReview;
  }

  function clearLegacyMeasurementsLineItems() {
    const lineItemsContainer = getLineItemsContainer();

    if (lineItemsContainer) {
      lineItemsContainer.innerHTML = '';
    }
  }

  function getStatusElement() {
    return document.querySelector('.measurements__status');
  }

  function setMeasurementsStatus(type, message) {
    const status = getStatusElement();

    if (!status) {
      return;
    }

    status.classList.remove(
      'measurements__status--idle',
      'measurements__status--loading',
      'measurements__status--success',
      'measurements__status--error'
    );

    status.classList.add('measurements__status--' + type);
    status.textContent = message;
  }

  function createStatusElement(control) {
    if (getStatusElement()) {
      return;
    }

    const statusElement = document.createElement('div');
    statusElement.classList.add('measurements__status', 'measurements__status--idle');
    statusElement.setAttribute('aria-live', 'polite');
    statusElement.textContent = 'Enter your Measurements ID to load saved measurements.';

    control.insertAdjacentElement('afterend', statusElement);
  }

  async function fetchMeasurementsByCode(code, signal) {
    const formData = new URLSearchParams();
    formData.append('code', String(code || '').trim());

    const response = await fetch(MEASUREMENTS_LOOKUP_URL, {
      method: 'POST',
      signal,
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded'
      },
      body: formData
    });

    const responseJson = await response.json();
    const responseData = responseJson.data || responseJson;

    if (
      !response.ok ||
      responseJson.error ||
      responseJson.ok === false ||
      responseData.error ||
      !Array.isArray(responseData.measurements)
    ) {
      throw new Error(
        responseJson.error ||
          responseData.error ||
          'Measurements ID was not found.'
      );
    }

    return responseData;
  }

  async function getMeasurements(code) {
    code = String(code || '').trim();

    if (!code) {
      lastLoadedCode = '';
      clearApoMeasurementFields();
      clearSizeSurchargeSelect();
      clearLegacyMeasurementsLineItems();

      setMeasurementsStatus(
        'idle',
        'Enter your Measurements ID to load saved measurements.'
      );

      return false;
    }

    if (isLoadingMeasurements && measurementsRequestController) {
      measurementsRequestController.abort();
    }

    isLoadingMeasurements = true;

    setMeasurementsStatus(
      'loading',
      'Checking Measurements ID…'
    );

    const requestController = new AbortController();
    const requestTimeout = setTimeout(function () {
      requestController.abort();
    }, MEASUREMENTS_REQUEST_TIMEOUT);

    measurementsRequestController = requestController;

    try {
      const responseData = await fetchMeasurementsByCode(code, requestController.signal);
      const latestInput = getMeasurementsInput();
      const latestCode = String((latestInput || {}).value || '').trim();

      if (latestCode !== code) {
        clearApoMeasurementFields();
        clearSizeSurchargeSelect();
        clearLegacyMeasurementsLineItems();
        return false;
      }

      if (!Array.isArray(responseData.measurements)) {
        console.log('Ошибка получения мерок:', responseData);
        clearApoMeasurementFields();
        clearSizeSurchargeSelect();
        clearLegacyMeasurementsLineItems();

        setMeasurementsStatus(
          'error',
          'Measurements ID was not found. Please check it.'
        );

        return false;
      }

      console.log('Мерки успешно получены:', responseData);

      clearApoMeasurementFields();
      clearSizeSurchargeSelect();
      clearLegacyMeasurementsLineItems();
      populateApoMeasurementFields(responseData);

      lastLoadedCode = code;
      lastMeasurementsSuccessMessage = applySizeSurchargeSelection(responseData);

      setMeasurementsStatus(
        'success',
        lastMeasurementsSuccessMessage
      );

      return true;

    } catch (error) {
      const latestInput = getMeasurementsInput();
      const latestCode = String((latestInput || {}).value || '').trim();

      if (error.name === 'AbortError' && latestCode !== code) {
        return false;
      }

      console.log('Ошибка получения мерок:', error);
      clearApoMeasurementFields();
      clearSizeSurchargeSelect();
      clearLegacyMeasurementsLineItems();

      setMeasurementsStatus(
        'error',
        'Measurements could not be checked. Please try again.'
      );

      return false;
    } finally {
      clearTimeout(requestTimeout);

      if (measurementsRequestController === requestController) {
        measurementsRequestController = null;
        isLoadingMeasurements = false;
      }
    }
  }

  function scheduleMeasurementsCheck() {
    const currentInput = getMeasurementsInput();

    if (!currentInput) {
      return;
    }

    const currentCode = String(currentInput.value || '').trim();

    lastSeenMeasurementsCode = currentCode;

    clearTimeout(measurementsInputTimer);

    if (!currentCode) {
      lastLoadedCode = '';
      clearApoMeasurementFields();
      clearSizeSurchargeSelect();
      clearLegacyMeasurementsLineItems();

      setMeasurementsStatus(
        'idle',
        'Enter your Measurements ID to load saved measurements.'
      );

      return;
    }

    if (lastLoadedCode && currentCode !== lastLoadedCode) {
      lastLoadedCode = '';
      clearApoMeasurementFields();
      clearSizeSurchargeSelect();
      clearLegacyMeasurementsLineItems();
    }

    if (currentCode === lastLoadedCode) {
      setMeasurementsStatus(
        'success',
        lastMeasurementsSuccessMessage
      );

      return;
    }

    if (isLoadingMeasurements) {
      setMeasurementsStatus(
        'loading',
        'Checking Measurements ID…'
      );
    } else {
      setMeasurementsStatus(
        'idle',
        'Enter your Measurements ID to load saved measurements.'
      );
    }

    measurementsInputTimer = setTimeout(function () {
      const latestInput = getMeasurementsInput();

      if (!latestInput) {
        return;
      }

      const latestCode = String(latestInput.value || '').trim();

      if (!latestCode || latestCode === lastLoadedCode) {
        return;
      }

      getMeasurements(latestCode);
    }, 600);
  }

  function scheduleMeasurementsCheckAfterValueUpdate() {
    setTimeout(scheduleMeasurementsCheck, 0);
  }

  function startMeasurementsValueWatcher() {
    if (measurementsValueWatcher) {
      return;
    }

    lastSeenMeasurementsCode = String((getMeasurementsInput() || {}).value || '').trim();

    measurementsValueWatcher = setInterval(function () {
      const currentInput = getMeasurementsInput();

      if (!currentInput) {
        return;
      }

      const currentCode = String(currentInput.value || '').trim();

      if (currentCode !== lastSeenMeasurementsCode) {
        scheduleMeasurementsCheck();
      }
    }, 100);
  }

  function initMeasurementsBlock() {
    const control = getMeasurementsControl();
    const input = getMeasurementsInput();

    if (!control || !input) {
      return false;
    }

    const inputContainer = control.closest('.mw-stack__item');

    if (!inputContainer) {
      return false;
    }

    if (!document.querySelector('.measurements__link')) {
      const element = document.createElement('div');
      element.classList.add('measurements__link');
      element.innerHTML = '<a href="https://measurements.brightandshinystore.com" target="_blank">Submit your measurements to get an ID</a>';

      inputContainer.insertAdjacentElement('beforebegin', element);
    }

    createStatusElement(control);

    startMeasurementsValueWatcher();

    if (!input.dataset.measurementsStatusReady) {
      input.dataset.measurementsStatusReady = 'true';

      input.addEventListener('input', scheduleMeasurementsCheck, true);
      input.addEventListener('keyup', scheduleMeasurementsCheck, true);
      input.addEventListener('change', scheduleMeasurementsCheck, true);
      input.addEventListener('beforeinput', scheduleMeasurementsCheckAfterValueUpdate, true);
      input.addEventListener('paste', scheduleMeasurementsCheckAfterValueUpdate, true);

      control.addEventListener('input', scheduleMeasurementsCheck, true);
      control.addEventListener('keyup', scheduleMeasurementsCheck, true);
      control.addEventListener('change', scheduleMeasurementsCheck, true);
      control.addEventListener('beforeinput', scheduleMeasurementsCheckAfterValueUpdate, true);
      control.addEventListener('paste', scheduleMeasurementsCheckAfterValueUpdate, true);

      if (!document.body.dataset.measurementsStatusEventsReady) {
        document.body.dataset.measurementsStatusEventsReady = 'true';

        function isMeasurementsInputEvent(event) {
          return event.target.closest && event.target.closest('.measurements');
        }

        document.addEventListener('input', function (event) {
          if (isMeasurementsInputEvent(event)) {
            scheduleMeasurementsCheck();
          }
        }, true);

        document.addEventListener('keyup', function (event) {
          if (isMeasurementsInputEvent(event)) {
            scheduleMeasurementsCheck();
          }
        }, true);

        document.addEventListener('change', function (event) {
          if (isMeasurementsInputEvent(event)) {
            scheduleMeasurementsCheck();
          }
        }, true);

        document.addEventListener('beforeinput', function (event) {
          if (isMeasurementsInputEvent(event)) {
            scheduleMeasurementsCheckAfterValueUpdate();
          }
        }, true);

        document.addEventListener('paste', function (event) {
          if (isMeasurementsInputEvent(event)) {
            scheduleMeasurementsCheckAfterValueUpdate();
          }
        }, true);
      }
    }

    return true;
  }

  window.addEventListener('load', function () {
    let attempts = 0;

    const timer = setInterval(function () {
      attempts += 1;

      if (initMeasurementsBlock() || attempts >= 20) {
        clearInterval(timer);
      }
    }, 500);
  });
})();

// set author on instagram's section
(function () {
  window.addEventListener('load', () => {
    setTimeout(() => {
      // const targets = document.querySelectorAll('.instafeed-container')
      const content = document.querySelectorAll('.instafeed-caption')
      content.forEach((element) => {
        const container = element.closest('.lightbox-instagram')
        const text = element.textContent 
        const username = text.match(/@\w.+/)[0].substr(1);  
        const newDiv = document.createElement("a");
        newDiv.setAttribute('href', `https://www.instagram.com/${username}`)
        newDiv.setAttribute('target', '_blank')
        newDiv.classList.add('instafeed-username')

        const newContent = document.createTextNode(`@${username}`);
        
        newDiv.appendChild(newContent);

        // const clone = newDiv.cloneNode(true);
        // targets[index].appendChild(newDiv); 
        container.appendChild(newDiv); 
      });
    }, 2000);
    
  })
})();
// set author on instagram's section